
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Login from './pages/public/auth/LoginPage';
import PhoneLogin from './pages/public/auth/PhoneLoginPage';
import ForgotPassword from './pages/public/auth/ForgotPasswordPage';
import ResetPassword from './pages/public/auth/ResetPasswordPage';
import ResetPasswordNextStep from './pages/public/auth/ResetPasswordNextStepPage';
import { Route, Routes } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { COLORS } from './enums/layout-enums';
import Privacy from './pages/public/privacy/PrivacyPage';
import Terms from './pages/public/terms/Terms';
import Uploader from './components/shared/Uploader';
import VerifyEmail from './pages/private/site/VerifyEmail';

const authContStyle = {
	marginTop: 16, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'
}

function AppPublic(props: any) {

	const history = useNavigate();

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<AppBar style={{ backgroundColor: COLORS.BLUE_BRAND_PRIMARY }}>
				<Toolbar>
					<img onClick={() => {
						history('/')
					}} alt={'logo'} width={150} style={{ cursor: 'pointer', float: 'left' }} src={process.env.PUBLIC_URL + '/logo.png'}></img>
					{/* <Typography style={{ cursor: 'pointer' }} onClick={() => {navigate('/')}} variant="h6" noWrap component="div">
            Acensa Health
          </Typography> */}
				</Toolbar>
			</AppBar>




			<Box component="main" sx={{ width: '100%', marginTop: 8 }}>

				<Routes>
					<Route path="/" element={<div style={authContStyle}></div>} />
					<Route path="ResetPasswordNextStep" element={<div style={authContStyle}>
						<ResetPasswordNextStep />
					</div>} />
					<Route path="PhoneLogin" element={<div style={authContStyle}>
						<PhoneLogin />
					</div>} />
					<Route path="Admin" element={<div style={authContStyle}>
						<Login />
					</div>} />
					<Route path="ForgotPassword" element={<div style={authContStyle}>
						<ForgotPassword />
					</div>} />
					<Route path="ResetPassword" element={<div style={authContStyle}>
						<ResetPassword />
					</div>} />
					<Route path="VerifyEmail" element={<div style={authContStyle}>
						<VerifyEmail />
					</div>} />
					<Route path="TestPhone" element={
						<div>
							<div onClick={() => window.open("acensahealth://open", "_blank")} style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}>
								LAUNCH APP 1
							</div>
							<br /><br />
							<a href="acensahealth://open">LAUNCH APP 2</a>
						</div>} />
					<Route path="Privacy" element={<Privacy />} />
					<Route path="Terms" element={<Terms />} />
				</Routes>
			</Box>
		</Box>
	)

}

export default AppPublic